import * as React from 'react';
import { cx } from 'linaria';
import * as styles from './shadow.styles';

export interface ShadowProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: 'flat' | 'small' | 'medium' | 'large' | 'extra-large';
    testId?: string;
}

export const Shadow = React.forwardRef<HTMLDivElement, ShadowProps>((props, ref) => {
    const { size = 'medium', testId, children, ...passThroughProps } = props;

    return (
        <div
            {...passThroughProps}
            className={cx(styles.root, size && styles.sizes[size], passThroughProps.className)}
            data-testid={testId}
            ref={ref}
        >
            {children}
        </div>
    );
});

Shadow.displayName = 'Shadow';
